import {
  PAYMENT_STATUS_LOADING,
  PAYMENT_STATUS_SUCCESS,
  PAYMENT_STATUS_FAILURE,
} from "redux/types";
import { Dispatch } from "redux";
import { listSingleItemService } from "services/listSingleItemService";
import { notification } from "antd";
import { paymentStatusUrl } from "api/apiUrls";

export const paymentStatusActions =
  (id: any, callback?: any) => async (dispatch: Dispatch) => {
    try {
      dispatch({ type: PAYMENT_STATUS_LOADING, payload: true });
      const response = await listSingleItemService(
        `${paymentStatusUrl}`,
        `?refid=web-${id}`
      );

      if (response.status !== 200) {
        notification.error({
          message: "Something went wrong",
        });
      }

      dispatch({ type: PAYMENT_STATUS_SUCCESS, payload: response.data });
    } catch (err) {
      dispatch({ type: PAYMENT_STATUS_FAILURE, payload: err });
    } finally {
      dispatch({ type: PAYMENT_STATUS_LOADING, payload: false });
    }
  };
